<template>
    <section>
        <nav>
            <ul>
                <li @click="()=>isActivePlans=false" :class="!isActivePlans?'active':''">{{ $tc("all") }}</li>
                <li @click="()=>isActivePlans=true" :class="isActivePlans?'active':''">{{$tc("devices.tabs.with_cloud")}}</li>
            </ul>
        </nav>
        <div class="devices" v-if="showDeviceList.length>0">
            <device-card
                v-for="device in showDeviceList"
                :key="device.uid"
                :device-info="device"
            />
        </div>
        <div v-else class="no-device">
            <img :src="ImgDeviceEmpty" alt="No Device"/>
            <p>{{ $tc("dashboard.no_device") }}</p>
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { getDeviceTotal } from '@/api/cloud';
import { getSubscriptions, getIccidByUid } from '@/api/subscriptions';
import { getCloudProductLists, getPlanById } from '@/api/cart';
import { unfoldError } from '@/common/js/notice';
import nprogress from 'nprogress';
import store from '@/store';
import { IDeviceModel, IEsim, IReolinkDeviceWithSubscription } from '@reolink-cloud/interface';
import DeviceCard from './components/DeviceCard.vue';
import ImgDeviceEmpty from 'IMAGE/dashboard/noDevice.png';

export default Vue.extend({
    components: {
        DeviceCard
    },
    data () {

        return {
            productList: {} as any,
            loadedCount: 0,
            deviceList: [] as IReolinkDeviceWithSubscription[],
            context: {},
            isActivePlans: false,
            esimProfile:[] as IEsim[],
            ImgDeviceEmpty
        };

    },
    async created () {

        try {

            this.productList = ( await getCloudProductLists({ lang: this.$i18n.locale }, 'all' )).cloudProductLists;
            await this.getDevicesList();

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        } finally {

            nprogress.done();

        }

        this.esimProfile = await getIccidByUid();

    },
    methods: {
        async getDevicesList () {

            let deviceList: IReolinkDeviceWithSubscription[] = await getDeviceTotal();

            let subs = await getSubscriptions( 'active' );
            for ( let device of deviceList ) {

                for ( let sub of subs.items ) {

                    if ( device.subscription === sub.id && device.status === 'associated' ) {

                        if ( typeof this.productList.plans[sub.plan] === 'undefined' ) {

                            let planDetails = await getPlanById( sub.plan );
                            device.planTitle = planDetails.series.i18n.name;
                            this.productList.plans[`${sub.plan}`] = planDetails.plan;
                            this.productList.plans[`${sub.plan}`].title = planDetails.series.i18n.name;
                            this.productList.planSeries[`${planDetails.plan.seriesKey}`] = planDetails.series;

                        } else {

                            device.planTitle = this.productList.plans[sub.plan].title;

                        }
                        device.subscriptionDetail = sub;

                    }

                }
                const deviceModel = this.productList.deviceModels[device.modelId] as IDeviceModel;
                device.modelImageUrl = deviceModel?.styles?.imageUrl;
                if ( typeof device.modelTitle === 'undefined' ) {

                    device.modelTitle = deviceModel?.title ?? device.model;

                }

            }
            this.deviceList = deviceList;
            this.loadedCount++;

        },

        async refreshDevicesList () {

            nprogress.start();
            try {

                await this.getDevicesList();

            } finally {

                nprogress.done();

            }

        },

        async hadEnforcedCMK () {

            await store.dispatch( 'getCMKS' );
            return Boolean( store.getters.enforcedCMK );

        }
    },
    computed: {
        howToBindUrl (): string {

            return this.$tc( 'dashboard.bind_url' );

        },
        showDeviceList(): IReolinkDeviceWithSubscription[] {

            const filteredList = this.deviceList.filter( item => {

                return !this.esimProfile.find( esim => esim.uid === item.uid );

            });

            if ( this.isActivePlans ) {

                return filteredList.filter( item => item.subscriptionDetail && ( item.subscriptionDetail.status === 'active' || item.boundStatus === 'bound' ));

            } else {

                return filteredList.filter( item => item.boundStatus === 'bound' );

            }

        },
    }
});
</script>

<style lang="less" scoped>
.devices {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .mobile({
        display: flex;
        flex-direction: column;
        gap: 16px;
    });

}
nav ul {
    display: flex;
    gap: 24px;
    margin: 24px 0;
    width: 100%;
    overflow: auto;

    @media @mobile {
        gap: 12px;
        position: relative;
        width: calc(100% + 20px);
        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;

        /* Firefox */
        &::-webkit-scrollbar {
            display: none;
        }
    }

    li {
        border: 1px solid @font_tertiary;
        border-radius: 8px;
        color: @font_secondary;
        cursor: pointer;
        padding: 10px 20px;
        font-weight: 500;
        font-size: 16px;
        white-space: nowrap;

        &:last-of-type {
            @media @mobile {
                margin-right: 20px;
            }
        }

        &.active {
            background-color: @b_1;
            border-color: @b_2;
            color: @b_6;
        }
    }
}
.no-device{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 21px;
    margin-top: 96px;
    margin-bottom: 138px;
    img {
        width: 160px;
    }
}
</style>
